import { PopupModel } from "@components"
import * as React from "react"
import axios from "axios"
import { useEffect, useRef, useState } from "react"
import { StaticImage } from "gatsby-plugin-image"
export const CustomQuoteForm = () => {
  const [formData, setFormData] = useState({
    ReferencesOfCompetitors: "",
    wireFrames: "",
    documents: "",
    documentUrl: "",
    pages: "",
    whatYouNeed: "",
    brandBookUrl: "",
    technology: "",
    pagesWithTitles: "",
    specificTechnology: "",
  })
  const [showSuccessPopup, setShowSuccessPopup] = useState(false)
  // file-state
  const [files, setFiles] = useState<{ [key: string]: any }>({})
  const [previews, setPreviews] = useState<{ [key: string]: string | null }>({}) // State to manage multiple previews
  const fileInputRefs: any = {
    documents: useRef<any>(null),
    brandBook: useRef<any>(null),
  }
  const submitHandler = () => {
    sendEmail()
    setShowSuccessPopup(true)
    setTimeout(() => {
      setShowSuccessPopup(false)
    }, 3000)
    setFormData({
      ReferencesOfCompetitors: "",
      wireFrames: "",
      documents: "",
      documentUrl: "",
      pages: "",
      whatYouNeed: "",
      brandBookUrl: "",
      technology: "",
      pagesWithTitles: "",
      specificTechnology: "",
    })
    // Reset files and previews state
    setFiles({})
    setPreviews({})

    // Reset file input refs
    Object.keys(fileInputRefs).forEach((key) => {
      if (fileInputRefs[key]?.current) {
        fileInputRefs[key].current.value = "" // Clear the file input
      }
    })
  }
  const [theme, setTheme] = useState<string | null>("")
  useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])
  const sendEmail = async () => {
    const emailData = {
      ReferencesOfCompetitors: formData.ReferencesOfCompetitors,
      wireFrames: formData.wireFrames,
      documents: formData.documents,
      documentUrl: formData.documentUrl,
      pages: formData.pages,
      whatYouNeed: formData.whatYouNeed,
      brandBookUrl: formData.brandBookUrl,
      technology: formData.technology,
      pagesWithTitles: formData.pagesWithTitles,
      specificTechnology: formData.specificTechnology,
    }
    const response = await fetch("/api/send-quote-email", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON?.stringify(emailData),
    })

    const data = await response.json()
  }
  const cloudFileUpload = async (file: any, fieldName: string) => {
    // Upload file to Cloudinary
    const formCloudData = new FormData()

    if (file) {
      formCloudData.append("file", file)
      formCloudData.append("upload_preset", "my_unsigned_preset")
    }

    try {
      const uploadResponse = await axios.post(
        `https://api.cloudinary.com/v1_1/djhafbofc/upload`,
        formCloudData
      )

      const fileUrl = uploadResponse.data.secure_url
      if (fieldName === "documents") {
        setFormData({
          ...formData,
          documentUrl: fileUrl,
        })
      }
      if (fieldName === "brandBook") {
        setFormData({
          ...formData,
          brandBookUrl: fileUrl,
        })
      }
    } catch (error) {
      console.error("Error:", error)
      alert(
        "Upload failed. Please try again or check your file format and size."
      )
    }
  }
  // Handle file selection
  const handleFileChange = (e: any, fieldName: string) => {
    const selectedFile = e.target.files[0]
    cloudFileUpload(selectedFile, fieldName)
    if (selectedFile) {
      setFiles((prev) => ({ ...prev, [fieldName]: selectedFile }))
      // Generate a preview URL for images, PDFs, or DOC files
      if (selectedFile.type.startsWith("image/")) {
        setPreviews((prev) => ({
          ...prev,
          [fieldName]: URL.createObjectURL(selectedFile),
        }))
      } else if (selectedFile.type === "application/pdf") {
        setPreviews((prev) => ({ ...prev, [fieldName]: "./document.png" })) // Use a generic file icon for other file types
      } else if (
        selectedFile.type === "application/msword" || // .doc
        selectedFile.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" // .docx
      ) {
        setPreviews((prev) => ({ ...prev, [fieldName]: "./document.png" })) // Use a generic file icon for other file types
        // Use a DOC icon
      } else {
        setPreviews((prev) => ({ ...prev, [fieldName]: "./document.png" })) // Use a generic file icon for other file types
        // Use a generic file icon for other file types
      }
    }
  }

  // Handle file removal
  const handleRemoveFile = (fieldName: string) => {
    setFiles((prev) => ({ ...prev, [fieldName]: null }))
    setPreviews((prev) => ({ ...prev, [fieldName]: null }))
    // Reset the file input value
    if (fileInputRefs[fieldName]?.current) {
      fileInputRefs[fieldName].current.value = ""
    }
  }
  return (
    <>
      <div className="custom-quote-bg backdrop-blur-2xl lg:w-full w-11/12 container mx-auto rounded-lg py-5 mb-10">
        <div className="flex w-full justify-center">
          <div className="w-full mx-5">
            <div className="pt-4 text-center">
              <p className="text-black lg:text-3xl font-semibold">
                "What we need from you to get started work on your project"
              </p>
            </div>
            <div className="pt-4 text-center">
              <p
                className={` lg:text-lg text-[10px] text-center ${theme == "glassy" ? "text-[#666666]" : theme === "light" ? "text-black" : theme === "dark" ? "text-black" : "text-[#666666]"}`}
              >
                Your partner offering unlimited revisions <br /> and full-time
                support for the work 🤝🏻
              </p>
            </div>
            <div className="mt-10">
              <p className="text-black text-center lg:text-lg text-xs font-semibold pb-2">
                Do you have References of competitors and inspirations?
              </p>
              <div className="w-full xl:shadow-none xl:bg-[unset] xl:py-0 py-3 px-3 xl:px-0 xl:rounded-[0px] rounded-xl">
                <input
                  value={formData.ReferencesOfCompetitors}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      ReferencesOfCompetitors: e.target.value,
                    })
                  }
                  className="bg-input bg-glass w-full pl-7 pr-3 custom-input-border py-3 font-light rounded-md text-sm outline-none text-black"
                  placeholder="Enter Your Answer"
                  type="text"
                />
              </div>
            </div>
            <div className="mt-8">
              <div className="w-full text-center flex justify-center">
                <p className="text-black text-center lg:w-7/12 px-5 lg:text-lg text-xs font-semibold pb-2">
                  Do you have Low fidelity wireframes or any hand sketches on
                  white paper about your idea or user-flow diagram?{" "}
                  <span className="text-[#7B68EC]">
                    (Or need from our service for it?)
                  </span>
                </p>
              </div>
              <div className="w-full xl:shadow-none xl:bg-[unset] xl:py-0 py-3 px-3 xl:px-0 xl:rounded-[0px] rounded-xl">
                <input
                  value={formData.wireFrames}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      wireFrames: e.target.value,
                    })
                  }
                  className="bg-input bg-glass w-full pl-7 pr-3 custom-input-border py-3 font-light rounded-md text-sm outline-none text-black"
                  placeholder="Enter Your Answer"
                  type="text"
                />
              </div>
            </div>
            <div className="mt-8">
              <div className="w-full text-center flex justify-center">
                <p className="text-black text-center lg:w-7/12 px-5 lg:text-lg text-xs font-semibold pb-2">
                  Do you have any documents ready for it?
                </p>
              </div>
              <div className="w-full xl:shadow-none xl:bg-[unset] flex gap-3 xl:py-0 py-3 px-3 xl:px-0 xl:rounded-[0px] rounded-xl">
                <input
                  value={formData.documents}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      documents: e.target.value,
                    })
                  }
                  className="bg-input bg-glass w-full pl-7 pr-3 custom-input-border py-3 font-light rounded-md text-sm outline-none text-black"
                  placeholder="Enter Your Answer"
                  type="text"
                />
                <div className="flex flex-col items-center gap-4">
                  {/* File Input Button */}
                  {(previews.documents === null ||
                    previews.documents === undefined) && (
                    <label
                      className={`text-sm py-3 lg:px-10 px-3 text-nowrap p-2 rounded-xl cursor-pointer ${theme == "glassy" ? "text-white bg-[#7b68ec]" : theme === "light" ? "bg-btn text-[#7b68ec]" : theme === "dark" ? "bg-btn text-[#7b68ec]" : "text-white bg-[#7b68ec]"}`}
                    >
                      Upload
                      <input
                        type="file"
                        className="hidden"
                        onChange={(e) => handleFileChange(e, "documents")}
                        accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document" // Allow images, PDFs, and DOC files
                        ref={fileInputRefs.documents} // Attach the ref to the file input
                      />
                    </label>
                  )}

                  {/* File Preview */}
                  {previews.documents && (
                    <div className="relative">
                      {files.documents.type.startsWith("image/") ? (
                        <img
                          src={previews.documents}
                          alt="Preview"
                          className="max-w-[50px] max-h-[50px] rounded-lg"
                        />
                      ) : (
                        <div className="flex flex-col items-center">
                          <StaticImage
                            src="./document.png"
                            alt="File Icon"
                            className="max-w-[30px] max-h-[50px]"
                          />
                          <p className="mt-2 text-sm">{files.documents.name}</p>
                        </div>
                      )}

                      {/* Remove Button */}
                      <button
                        onClick={() => handleRemoveFile("documents")}
                        className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center"
                      >
                        ×
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="mt-8">
              <div className="w-full text-center flex justify-center">
                <p className="text-black text-center px-5 lg:text-lg text-xs font-semibold pb-2">
                  Do you have a logo or specific colors or a brand guide?
                  <span className="text-[#7B68EC]">
                    (Or need from our service for it?)
                  </span>
                </p>
              </div>
              <div className="w-full xl:shadow-none xl:bg-[unset] flex gap-3 xl:py-0 py-3 px-3 xl:px-0 xl:rounded-[0px] rounded-xl">
                <input
                  value={formData.whatYouNeed}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      whatYouNeed: e.target.value,
                    })
                  }
                  className="bg-input bg-glass w-full pl-7 pr-3 custom-input-border py-3 font-light rounded-md text-sm outline-none text-black"
                  placeholder="Enter Your Answer"
                  type="text"
                />
                <div className="flex flex-col items-center gap-4">
                  {/* File Input Button */}
                  {(previews.brandBook === null ||
                    previews.brandBook === undefined) && (
                    <label
                      className={`text-sm py-3 lg:px-10 px-3 text-nowrap p-2 rounded-xl cursor-pointer ${theme == "glassy" ? "text-white bg-[#7b68ec]" : theme === "light" ? "bg-btn text-[#7b68ec]" : theme === "dark" ? "bg-btn text-[#7b68ec]" : "text-white bg-[#7b68ec]"}`}
                    >
                      Upload
                      <input
                        type="file"
                        className="hidden"
                        onChange={(e) => handleFileChange(e, "brandBook")}
                        accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document" // Allow images, PDFs, and DOC files
                        ref={fileInputRefs.brandBook} // Attach the ref to the file input
                      />
                    </label>
                  )}

                  {/* File Preview */}
                  {previews.brandBook && (
                    <div className="relative">
                      {files.brandBook.type.startsWith("image/") ? (
                        <img
                          src={previews.brandBook}
                          alt="Preview"
                          className="max-w-[50px] max-h-[50px] rounded-lg"
                        />
                      ) : (
                        <div className="flex flex-col items-center">
                          <StaticImage
                            src="./document.png"
                            alt="File Icon"
                            className="max-w-[30px] max-h-[50px]"
                          />
                          <p className="mt-2 text-sm">{files.brandBook.name}</p>
                        </div>
                      )}

                      {/* Remove Button */}
                      <button
                        onClick={() => handleRemoveFile("brandBook")}
                        className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center"
                      >
                        ×
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="mt-8">
              <div className="w-full text-center flex justify-center">
                <p className="text-black text-center px-5 lg:text-lg text-xs font-semibold pb-2">
                  How many pages/screens do you need to design?
                </p>
              </div>
              <div className="w-full xl:shadow-none xl:bg-[unset] xl:py-0 py-3 px-3 xl:px-0 xl:rounded-[0px] rounded-xl">
                <input
                  value={formData.pages}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      pages: e.target.value,
                    })
                  }
                  className="bg-input bg-glass w-full pl-7 pr-3 custom-input-border py-3 font-light rounded-md text-sm outline-none text-black"
                  placeholder="Enter Your Answer"
                  type="text"
                />
              </div>
            </div>
            <div className="mt-8">
              <div className="w-full text-center flex justify-center">
                <p className="text-black text-center px-5 lg:w-7/12 lg:text-lg text-xs font-semibold pb-2">
                  Do you need (Website/Mobile App/Dashboard/Admin/wireframe)
                  only desktop or mobile responsive{" "}
                  <span className="text-[#7B68EC]">
                    (Mobile friendly design)
                  </span>{" "}
                  as well?
                </p>
              </div>
              <div className="w-full xl:shadow-none xl:bg-[unset] xl:py-0 py-3 px-3 xl:px-0 xl:rounded-[0px] rounded-xl">
                <input
                  value={formData.technology}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      technology: e.target.value,
                    })
                  }
                  className="bg-input bg-glass w-full pl-7 pr-3 custom-input-border py-3 font-light rounded-md text-sm outline-none text-black"
                  placeholder="Enter Your Answer"
                  type="text"
                />
              </div>
            </div>
            <div className="mt-8">
              <div className="w-full text-center flex justify-center">
                <p className="text-black text-center px-5 lg:text-lg text-xs font-semibold pb-2">
                  Please specify the pages with titles and content that you need
                  to design for now?
                </p>
              </div>
              <div className="w-full xl:shadow-none xl:bg-[unset] xl:py-0 py-3 px-3 xl:px-0 xl:rounded-[0px] rounded-xl">
                <input
                  value={formData.pagesWithTitles}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      pagesWithTitles: e.target.value,
                    })
                  }
                  className="bg-input bg-glass w-full pl-7 pr-3 custom-input-border py-3 font-light rounded-md text-sm outline-none text-black"
                  placeholder="Enter Your Answer"
                  type="text"
                />
              </div>
            </div>
            <div className="mt-8">
              <div className="w-full text-center flex justify-center">
                <p className="text-black text-center px-5 lg:w-7/12 lg:text-lg text-xs font-semibold pb-2">
                  Do you have any specific technology to get started or need
                  recommendations from our side which is best fit for your
                  industry?
                </p>
              </div>
              <div className="w-full xl:shadow-none xl:bg-[unset] xl:py-0 py-3 px-3 xl:px-0 xl:rounded-[0px] rounded-xl">
                <input
                  value={formData.specificTechnology}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      specificTechnology: e.target.value,
                    })
                  }
                  className="bg-input bg-glass w-full pl-7 pr-3 custom-input-border py-3 font-light rounded-md text-sm outline-none text-black"
                  placeholder="Enter Your Answer"
                  type="text"
                />
              </div>
            </div>
            <div className="pt-10 text-center">
              <p className="text-black lg:text-3xl font-semibold">
                These things are a really good understanding of a great start 🤞🏻
              </p>
            </div>
            <div className="flex justify-center mt-10">
              <button
                disabled={
                  !(
                    formData.ReferencesOfCompetitors ||
                    formData.wireFrames ||
                    formData.documents ||
                    formData.pages ||
                    formData.technology ||
                    formData.pagesWithTitles ||
                    formData.specificTechnology ||
                    formData.whatYouNeed
                  )
                }
                onClick={() => submitHandler()}
                className="border border-[#9F69FF] disabled:opacity-50 disabled:cursor-not-allowed py-2 font-semibold text-[#7B68EC] rounded-lg w-[80%]"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
      {showSuccessPopup && (
        <PopupModel className="lg:col-span-6 lg:col-start-6 col-span-full mx-3">
          <div className="flex justify-center items-center py-8 flex-col">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="50"
              height="50"
              viewBox="0 0 100 100"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 50C0 36.7392 5.26784 24.0215 14.6447 14.6447C24.0215 5.26784 36.7392 0 50 0C63.2608 0 75.9785 5.26784 85.3553 14.6447C94.7322 24.0215 100 36.7392 100 50C100 63.2608 94.7322 75.9785 85.3553 85.3553C75.9785 94.7322 63.2608 100 50 100C36.7392 100 24.0215 94.7322 14.6447 85.3553C5.26784 75.9785 0 63.2608 0 50ZM47.1467 71.4L75.9333 35.4133L70.7333 31.2533L46.1867 61.9267L28.8 47.44L24.5333 52.56L47.1467 71.4Z"
                fill="#1DBF72"
              />
            </svg>
            <p className="text-[#00A255] lg:text-2xl text-lg font-bold text-center mt-8 py-3">
              “Successfully Submitted"
            </p>
            <div className="text-center text-black !leading-[1.5] lg:text-2xl text-lg font-bold pt-5">
              <p>
                We'll Contact You Within 1 <br />
                Hour Regarding The Project 🚀
              </p>
            </div>
          </div>
        </PopupModel>
      )}
    </>
  )
}
